/**
 * Eldra — paginazione collezione/ricerca veloce (AJAX + prefetch).
 * Evita il reload completo di header/footer/app quando si clicca 2, 3, …
 */
(() => {
  if (window.__eldraCollectionPaginationBound) return;
  window.__eldraCollectionPaginationBound = true;

  const getSearchParamsFromUrl = (href) => {
    try {
      return new URL(href, window.location.origin).searchParams.toString();
    } catch (e) {
      return '';
    }
  };

  const getSectionId = () => document.getElementById('product-grid')?.dataset?.id || '';

  const showLoading = () => {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    grid.classList.add('eldra-pagination-loading');
    grid.querySelector('.collection')?.classList.add('loading');
  };

  const scrollToGridFast = () => {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    const root = document.documentElement;
    const header =
      parseInt(getComputedStyle(root).getPropertyValue('--eldra-home-header-current-height'), 10) ||
      parseInt(getComputedStyle(root).getPropertyValue('--eldra-home-header-compact-height'), 10) ||
      80;
    const top = Math.max(0, container.getBoundingClientRect().top + window.scrollY - header - 12);
    window.scrollTo({ top, behavior: 'auto' });
  };

  const prefetchHref = (href) => {
    if (!href || typeof FacetFiltersForm === 'undefined') return;
    const sectionId = getSectionId();
    if (!sectionId) return;
    const searchParams = getSearchParamsFromUrl(href);
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    if (FacetFiltersForm.filterData.some((item) => item.url === url)) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        if (!FacetFiltersForm.filterData.some((item) => item.url === url)) {
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        }
      })
      .catch(() => {});
  };

  const prefetchNeighbors = () => {
    document.querySelectorAll('.pagination a.pagination__item[href]').forEach((link) => {
      prefetchHref(link.href);
    });
  };

  const schedulePrefetch = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => prefetchNeighbors(), { timeout: 2200 });
    } else {
      window.setTimeout(prefetchNeighbors, 900);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('.pagination a.pagination__item[href]');
      if (!link) return;
      if (link.getAttribute('aria-current') === 'page' || link.getAttribute('aria-disabled') === 'true') return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      if (typeof FacetFiltersForm === 'undefined' || !getSectionId()) return;

      event.preventDefault();
      showLoading();
      scrollToGridFast();

      const searchParams = getSearchParamsFromUrl(link.href);
      FacetFiltersForm.renderPage(searchParams, null, true);
      window.setTimeout(schedulePrefetch, 350);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePrefetch, { once: true });
  } else {
    schedulePrefetch();
  }
})();
